import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: 'e2076f96-fa4d-4987-8213-b133597b30f6',
  header: 'Salubi',
  headerLogoUrl: {
    light: '/logos/salubi.png',
    dark: '/logos/salubi.png',
  },
  subheader: 'Legemiddelsok (SPC)',
  version: 'Beta 6.0',
  logo: '/logos/salubi.png',
  theme: {
    isLight: false,
    bgColor: 'bg-[#2f8f97]',
    textColor: 'text-[#1e6b73]',
    bubbles: 'bg-[#256f76]',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    (process.env.REACT_APP_SALUBI_CHATBOT_PATH || '/api/v1/chatbots/spc'),
}

export default config
